export interface LeaseAgreementTncDocuments {
    id: string;
    terms_and_condition_fk: any;
    documents: any;
    terms_and_condition_text: string;
}
export class LeaseAgreementTncDocumentsClass implements LeaseAgreementTncDocuments {
    id: string;
    terms_and_condition_fk: any;
    documents: any;
    terms_and_condition_text: string;

    constructor() {
        this.id = null;
        this.terms_and_condition_fk = null;
        this.documents = null;
        this.terms_and_condition_text = null;
    }
}
